import React from 'react';
import styles from './styles';

export const RBHImage = (props: any) => {
  return (
    <img {...props} style={{ ...styles.imageDefault, ...props.style }}>
    </img>
  );
};

export default RBHImage;
